var localizedProductList = function() {
	var categoryTitle = "##GROUPNAME##";	
	var colorFilterTitle = "##COLORNAME##";
	var greaterThanFormat = "##PRICE## and above";
	var lessThanFormat = "Less than ##PRICE##";
	var priceFilterTitle = '##PRICELOW## to ##PRICEHIGH##';
	var productionTimeFilterTitle = 'ships in ##PRODTIME## days';
	var imprintLocationCountFilterTitle = '##IMPLOC## Imprint Location(s)';
	var imprintColorCountFilterTitle = '##IMPCOLOR## Imprint Color(s)';
	var ratingFilterTitle = '##RATING## star rating';
	var tagFilterTitle = '##TAGNAME##';
	var pageNumberTitle = 'Page ##PAGENUM##';
	var pageSizeTitle = 'Displaying ##PAGESIZE## Products';
	var pageSortTitle = 'Sorted By ##SORTDESC##';
	var subSearchTitle = '';  //we don't currently add the subSearch to the Title - blah
	var selectedPriceRangeFormat = 'From ##min## to ##max##';
	var selectedSubSearchFormat = 'Contains "##search##"';
	var subSearchPlaceHolder = 'Search within these results';
	var newSubSearchPlaceHolder = 'Search for a different term';
	var freeSetupLink = {link: '<a href="/freesetup" class="clear noLine text13 uppercase textsemibold"><span class="textBlue">Free Set-up</span></a>', base: '/freesetupitems', title: 'See our products with free setup'};
	var exclusiveLink = {link: '<a href="/exclusive" class="clear noLine text13 uppercase textsemibold"><span class="textBlue">Exclusive</span></a>', base: '/tagitems/3', title: 'See products exclusive to 4imprint'};
	var saleLink = {link:'<a href="/sale" class="clear noLine text13 uppercase textsemibold"><span class="textRed">On Sale!</span></a>', base: '/saleitems', title: 'See our sale products'};
	var closeoutLink = {link:'<a href="/closeout" class="clear noLine text13 uppercase textsemibold"><span class="textDkRed">Closeout</span></a>', base:'/tagitems/2', title: 'See our closeout products'};
	var priceDropLink = {link:'<a href="/pricedrops" class="clear noLine text13 uppercase textsemibold"><span class="textBlue">New Lower Price!</span></a>', base:'/pricedropitems', title:'See our price drop products'};
	var saleTagID = 426;
	var hottestTagID = 427;
	var newTagID = 428;
	return {
		CategoryTitle: categoryTitle,
		ColorFilterTitle: colorFilterTitle,
		GreaterThanFormat: greaterThanFormat,
		LessThanFormat: lessThanFormat,
		PriceFilterTitle: priceFilterTitle,
		ProductionTimeFilterTitle: productionTimeFilterTitle,
		ImprintLocationCountFilterTitle: imprintLocationCountFilterTitle,
		ImprintColorCountFilterTitle: imprintColorCountFilterTitle,
		RatingFilterTitle: ratingFilterTitle,
		TagFilterTitle: tagFilterTitle,
		PageNumberTitle: pageNumberTitle,
		PageSizeTitle: pageSizeTitle,
		PageSortTitle: pageSortTitle,
		SubSearchTitle: subSearchTitle,
		SelectedPriceRangeFormat: selectedPriceRangeFormat,
		SelectedSubSearchFormat: selectedSubSearchFormat,
		SubSearchPlaceHolder: subSearchPlaceHolder,
		NewSubSearchPlaceHolder: newSubSearchPlaceHolder,
		FreeSetupLink: freeSetupLink,
		ExclusiveLink: exclusiveLink,
		SaleLink: saleLink,
		CloseoutLink: closeoutLink,
		PriceDropLink: priceDropLink,
		SaleTagID: saleTagID,
		HottestTagID: hottestTagID,
		NewTagID: newTagID
	};
};